import axios from "axios";
import apiurl from "../apiendpoint/apiendpoint";
import { gettoken } from "../../../../shared/services/token/token";

export const apisaveNotifications = async (datas) => {
    try {
        const token = gettoken();
        const res = await axios.post(`${apiurl()}/notifications/apisavenotifications`, datas, { headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" }});

        return res.data;
    } catch (err) {
        console.log(err);
    }
};



export const apigetallNotifications = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/notifications/apigetallnotifications`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};


export const apideleteNotifications = async (_id) => {
    try {
        const token = gettoken();
        const res = await axios.delete(`${apiurl()}/notifications/apideletenotifications/${_id}`,{headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apiupdateNotifications = async (_id,datas) => {
    try {
        const token = gettoken();
        const res = await axios.put(`${apiurl()}/notifications/apiupdatenotifications/${_id}`, datas,{headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};